import { useState } from 'react';
import type { JournalEntry } from '../../types/journal';
import { generateJournalCsv, downloadCsv, getExportFilename } from '../../utils/exportCsv';

interface ExportButtonProps {
  entries: JournalEntry[];
  disabled: boolean;
}

export function ExportButton({ entries, disabled }: ExportButtonProps) {
  const [error, setError] = useState<string | null>(null);

  function handleExport() {
    setError(null);
    try {
      const csvContent = generateJournalCsv(entries);
      downloadCsv(csvContent, getExportFilename());
    } catch {
      setError('Export failed. Please try again.');
    }
  }

  return (
    <div className="export-button-container">
      <button
        className="cta-button"
        onClick={handleExport}
        disabled={disabled}
        title={disabled ? 'Log entries to enable export' : undefined}
      >
        Export CSV
      </button>
      {error && (
        <div className="error-message" role="alert">
          <p>{error}</p>
          <button className="cta-button" onClick={handleExport} style={{ marginTop: '0.5rem' }}>
            Retry
          </button>
        </div>
      )}
    </div>
  );
}
